(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('TestServices', TestServices);

    TestServices.$inject = ['$resource', 'ENV'];

    function TestServices($resource, ENV) {


        var getCompanyInfoByKeyURL = function (keyURL) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-company-info-by-key-url?url=' + keyURL;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getRootCategoriesByKeyURL = function (keyURL) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-root-categories-by-key-url?url=' + keyURL;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCategoriesByParentId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-categories-by-parent/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceItemByCategoryId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-item-by-category/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCategoryById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-category-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getServiceItemById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-item-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getServiceTimeSessionFromToDate = function (serviceItemid, from, to) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-from-to-date?serviceItemId=' + serviceItemid + '&from=' + from + '&to=' + to;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceTimeSessionTimesInOneDate = function (serviceItemId, dateTimeStr) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-times-in-one-date?serviceItemId=' + serviceItemId + '&dateTimeStr=' + dateTimeStr;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getPriceInfoDtailByServiceItemFromTimeSession = function (serviceItemId, serviceTimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/price-info-dtails-by-service-item-from-time-session?serviceItemId=' + serviceItemId + '&serviceTimeSessionId=' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceOptionItemsByServiceItemId = function (serviceItemId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/service-option-items-by-service-item?serviceItemId=' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getServiceTimeSessionById = function (serviceTimeSessionId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-service-time-session-by-id?serviceTimeSessionId=' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getImageDataById = function (imageDataId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-image-data-by-id?imageDataId=' + imageDataId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var saveOrderBagVM = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/order-bags';
            return $resource(resourceUrl, {}, {}
            );
        };


        var testReminder = function (testReminder) {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-reminder';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getImageDataVMByAlbumId = function (albumId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/image-data-vm-by-albumid?albumid=' + albumId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var sendTestSMS = function (keyUrl, phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms?keyUrl=' + keyUrl + '&phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServicesJustOnDate = function (untilDate) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesJustOnDate/' + untilDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServicesJustOnDateOneCompany = function (untilDate, url) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesJustOnDateOneCompany/' + untilDate + '/' + url;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var generateTimeSessionsForAllServices = function (untilDate) {

            var resourceUrl = ENV.API_BASE_URL + 'api/generateTimeSessionsForAllServicesUntilDate/' + untilDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestEmail = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-email';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var finalApproveOrderBagById = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'client/final-approve-order-bag-by-id?orderBagId=' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testSubscriptionNearToExpire = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-subscription-near-to-expire';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var testUpdateExpireCompanyStatus = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-update-expire-company-status';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var confirmReserveRequest = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/confirm-reserve-request-by-order-bag-id?orderBagId=' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var insertNewConversation = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/insert-new-conversation';
            return $resource(resourceUrl, {}, {}
            );
        };

        var insertNewMessage = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/insert-new-message';
            return $resource(resourceUrl, {}, {}
            );
        };

        var cancelAllExpireTwoStepReserve = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/cancel-all-expire-two-step-reserve';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var getServiceAvailableDatesInNextDays = function (serviceItemId, nextDays) {

            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-service-available-dates-in-next-days?serviceId=' + serviceItemId + "&days=" + nextDays;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getServiceAvailableTimesInOneDate = function (serviceItemId, onDate, fromHour, toHour) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-service-available-times-in-one-shamsi-date?serviceId=' + serviceItemId + "&onDateStr=" + onDate;
            if (fromHour != undefined)
                resourceUrl = resourceUrl + "&fromHour=" + fromHour;
            if (toHour != undefined)
                resourceUrl = resourceUrl + "&toHour=" + toHour;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var getCustomerByMobileNumber = function (mobileNumber) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-customer-by-mobile-number/' + mobileNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var addTaminBranch = function (title, url, user, baseurl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-tamin-branch?companyurl=' + url + '&companytitle=' + title + '&username=' + user + '&basecompanyurl=' + baseurl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var addLocation = function (companyId, tel) {
            var resourceUrl = ENV.API_BASE_URL + 'api/location-info-add-to-company-title/' + companyId + "?tel=" + tel;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var findcompanyByTitle = function (title) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-title?title=' + title;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var findcompanyByKeyUrl = function (keyUrl) {
            var resourceUrl = ENV.API_BASE_URL + 'api/find-company-by-key-url?keyUrl=' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }
        var exportOrderBagToExcel = function (serviceItemid) {

            var resourceUrl = ENV.API_BASE_URL + 'api/export-orderbags-by-service-item?serviceItemId=' + serviceItemid;
            return $resource(resourceUrl, {}, {}
            );
        }

        var sendTestCustomerSatisfactionSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-satisfaction-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }


        var addDaysToSubscriptionByCompany = function (companyKeyUrl, days) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-days-to-subscription-by-company?companyKeyUrl=' + companyKeyUrl + '&daysToAdd=' + days;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var addFreeSMSPackage = function (companyKeyUrl, starDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-free-sms-package-to-company?companyKeyUrl=' + companyKeyUrl + '&startDate=' + starDate;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var addCustomSMSPackage = function (companyKeyUrl, packageid, starDate) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-custom-sms-package-to-company?companyKeyUrl=' + companyKeyUrl + '&startDate=' + starDate + '&packageid=' + packageid;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var getCompaniesSubscriptionNearToExpire = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-companies-subscription-near-to-expire';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var sendTestCustomerFirstReminderSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-first-reminder-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getTopNCompanyManager = function (recordCount) {

            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-top-n-company-manager?recordCount=' + recordCount;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getServantByMarketPlaceFilter = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/client/get-servants-by-marketplace-filter';
            return $resource(resourceUrl, {}, {
                'query': {method: 'POST', isArray: true}
            });

        }

        var addDaysToSubscriptionByCompaniesCategory = function (category, days) {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-days-to-subscription-by-companies-category?category=' + category + '&daysToAdd=' + days;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var setFeatureByCompanySubscriptionId = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/set-feature-by-company-subscription-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestReservationConfirmedInfoMsg = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-reservation-confirmed-info-msg/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var getToken = function () {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-token';
            return $resource(resourceUrl, {}, {}
            );
        };

        var createUserAccessForServantByPhoneNumber = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/create-user-access-for-servant-by-phone-number';
            return $resource(resourceUrl, {}, {}
            );
        };

        var getReserveListByCustomer = function (mobileNumber) {
            var resourceUrl = ENV.API_BASE_URL + 'rw-open-api/get-reserve-list-by-customer?mobileNo=' + mobileNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var addBatchCustomer = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-batch-customer';
            return $resource(resourceUrl, {}, {}
            );
        };

        var testIcalCalendat = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/test-ical-calendar';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        }

        var sendVerificationTestSMS = function (keyUrl, phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-verification-test-sms?keyUrl=' + keyUrl + '&phoneNumber=' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        var sendRebookNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-rebook-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendRebookSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-rebook-sms-test/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestCustomerSecondReminderSMS = function (orderBagId) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-customer-second-reminder-sms/' + orderBagId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSMSPackageGoingToFinish = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms-package-going-finish/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSMSPackageFinished = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-sms-package-finished/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSubscriptionNearToExpireNotification = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-subscription-near-to-expire-notification/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendTestSubscriptionIsExpiredNotification = function (keyUrl) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-subscription-is-expired-notification/' + keyUrl;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestAutomaticSubscriptionNearToExpireNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-automatic-near-to-expired-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestAutomaticApproveReserveRequest = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-automatic-approve-reserve-request';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var sendAllSatisfactionNotification = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-all-satisfaction-notification';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };
        var sendTestSupplierFirstJourneyNotification = function (phoneNumber) {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-test-supplier-first-journey/' + phoneNumber;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var getInvoiceReportPdfUrl = function (id) {

            return ENV.API_BASE_URL + 'api/client/invoice-report-pdf-by-id/' + id;

        };

        var addBatchInvoiceInfo = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/add-batch-invoice-info';
            return $resource(resourceUrl, {}, {}
            );
        };
        var sendAutomaticMarketingCampaign = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/send-automatic-marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testCalculateCommission = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-calculate-commission';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

        var testSmsNearFinish = function () {

            var resourceUrl = ENV.API_BASE_URL + 'api/test-sms-near-finish';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };

       var testSendMarketingCampaign = function () {
           var resourceUrl =
               ENV.API_BASE_URL +
               'api/test-send-sms-panel-marketing-campaigns';

           return $resource(resourceUrl, {}, {
               send: {
                   method: 'POST',
                   params: {
                       marketingCampaignId: '@marketingCampaignId'
                   }
               }
           });
       };
       var removePhoneNumber = function () {
           var resourceUrl =
               ENV.API_BASE_URL +
               'api/users';

           return $resource(resourceUrl, {}, {
               delete: {
                   method: 'DELETE',
                   params: {
                       phoneNumber: '@phoneNumber'
                   }
               }
           });
       };


        return {
            getCompanyInfoByKeyURL: getCompanyInfoByKeyURL,
            getRootCategoriesByKeyURL: getRootCategoriesByKeyURL,
            getCategoriesByParentId: getCategoriesByParentId,
            getServiceItemByCategoryId: getServiceItemByCategoryId,
            getCategoryById: getCategoryById,
            getServiceItemById: getServiceItemById,
            getServiceTimeSessionFromToDate: getServiceTimeSessionFromToDate,
            getServiceTimeSessionTimesInOneDate: getServiceTimeSessionTimesInOneDate,
            getPriceInfoDtailByServiceItemFromTimeSession: getPriceInfoDtailByServiceItemFromTimeSession,
            getServiceOptionItemsByServiceItemId: getServiceOptionItemsByServiceItemId,
            getServiceTimeSessionById: getServiceTimeSessionById,
            getImageDataById: getImageDataById,
            saveOrderBagVM: saveOrderBagVM,
            testReminder: testReminder,
            getImageDataVMByAlbumId: getImageDataVMByAlbumId,
            sendTestSMS: sendTestSMS,
            sendTestEmail: sendTestEmail,
            finalApproveOrderBagById: finalApproveOrderBagById,
            generateTimeSessionsForAllServices: generateTimeSessionsForAllServices,
            generateTimeSessionsForAllServicesJustOnDate: generateTimeSessionsForAllServicesJustOnDate,
            generateTimeSessionsForAllServicesJustOnDateOneCompany: generateTimeSessionsForAllServicesJustOnDateOneCompany,
            testSubscriptionNearToExpire: testSubscriptionNearToExpire,
            testUpdateExpireCompanyStatus: testUpdateExpireCompanyStatus,
            confirmReserveRequest: confirmReserveRequest,
            insertNewConversation: insertNewConversation,
            insertNewMessage: insertNewMessage,
            cancelAllExpireTwoStepReserve: cancelAllExpireTwoStepReserve,
            exportOrderBagToExcel: exportOrderBagToExcel,
            getServiceAvailableDatesInNextDays: getServiceAvailableDatesInNextDays,
            getServiceAvailableTimesInOneDate: getServiceAvailableTimesInOneDate,
            getCustomerByMobileNumber: getCustomerByMobileNumber,
            addTaminBranch: addTaminBranch,
            addLocation: addLocation,
            findcompanyByTitle: findcompanyByTitle,
            findcompanyByKeyUrl: findcompanyByKeyUrl,
            sendTestCustomerSatisfactionSMS: sendTestCustomerSatisfactionSMS,
            addDaysToSubscriptionByCompany: addDaysToSubscriptionByCompany,
            getCompaniesSubscriptionNearToExpire: getCompaniesSubscriptionNearToExpire,
            addFreeSMSPackage: addFreeSMSPackage,
            addCustomSMSPackage: addCustomSMSPackage,
            sendTestCustomerFirstReminderSMS: sendTestCustomerFirstReminderSMS,
            getTopNCompanyManager: getTopNCompanyManager,
            getServantByMarketPlaceFilter: getServantByMarketPlaceFilter,
            addDaysToSubscriptionByCompaniesCategory: addDaysToSubscriptionByCompaniesCategory,
            setFeatureByCompanySubscriptionId: setFeatureByCompanySubscriptionId,
            sendTestReservationConfirmedInfoMsg: sendTestReservationConfirmedInfoMsg,
            getToken: getToken,
            createUserAccessForServantByPhoneNumber: createUserAccessForServantByPhoneNumber,
            getReserveListByCustomer: getReserveListByCustomer,
            addBatchCustomer: addBatchCustomer,
            testIcalCalendat: testIcalCalendat,
            sendVerificationTestSMS: sendVerificationTestSMS,
            sendRebookNotification: sendRebookNotification,
            sendRebookSMS: sendRebookSMS,
            sendTestCustomerSecondReminderSMS: sendTestCustomerSecondReminderSMS,
            sendTestSMSPackageGoingToFinish: sendTestSMSPackageGoingToFinish,
            sendTestSMSPackageFinished: sendTestSMSPackageFinished,
            sendTestSubscriptionNearToExpireNotification: sendTestSubscriptionNearToExpireNotification,
            sendTestSubscriptionIsExpiredNotification: sendTestSubscriptionIsExpiredNotification,
            sendTestAutomaticSubscriptionNearToExpireNotification: sendTestAutomaticSubscriptionNearToExpireNotification,
            sendTestAutomaticApproveReserveRequest: sendTestAutomaticApproveReserveRequest,
            sendAllSatisfactionNotification: sendAllSatisfactionNotification,
            sendTestSupplierFirstJourneyNotification: sendTestSupplierFirstJourneyNotification,
            getInvoiceReportPdfUrl: getInvoiceReportPdfUrl,
            addBatchInvoiceInfo: addBatchInvoiceInfo,
            sendAutomaticMarketingCampaign: sendAutomaticMarketingCampaign,
            testCalculateCommission: testCalculateCommission,
            testSmsNearFinish: testSmsNearFinish,
            testSendMarketingCampaign:testSendMarketingCampaign,
            removePhoneNumber: removePhoneNumber


        };
    }
})();
